let setupRegionalLocaleSelect = select =>
  $(select).find('li').click(function(event) {
    let item = event.target,
        $form = $(select).closest('form'),
        $input = $form.find('input[name="force_locale"]'),
        oldLocale = $input.val(),
        newLocale = $(item).attr('value');
    if (newLocale === oldLocale) {
      return $(select).siblings('.dropdown-toggle').dropdown('toggle');
    } else {
      $form.find('input[name="force_locale"]').val(newLocale);
      return $form.submit();
    }
  })
;

$(document).ready(() =>
  Array.prototype.forEach.call(document.querySelectorAll('.js-regional-locale-select'), select => {
    return setupRegionalLocaleSelect(select);
  })
);



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/jsRegionalLocaleSelect.js